import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Button from "../../../components/atoms/button";
import Loading from "../../../components/atoms/loading";
import Select from "../../../components/atoms/select";
import NavBar from "../../../components/organisms/navbar";
import useAuthenticate from "../../../hooks/useAuthenticate";
import api from "../../../services/api";
import { Content, FormContainer, PageDescription, PageTitle } from "../styles";
import SelectFighters from "../../../components/atoms/selectFighters";
import SelectCategories from "src/components/atoms/selectCategories";
import rulesOpenChallengerDeJiuJitsu2025Gi from "../../../data/rules-open-challenger-de-jiu-jitsu-2025-gi.json";
import rulesOpenChallengerDeJiuJitsu2025NoGi from "../../../data/rules-open-challenger-de-jiu-jitsu-2025-nogi.json";
import {
  Checkbox,
  Collapse,
  Fade,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import Swal from "sweetalert2";
import NoOptionsAlert from "src/components/atoms/no-options-alert";
import { Stack, Typography, Box } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import EditFighterModal from "src/components/atoms/editAtleteModal";

const EnrollmentOpenChallengerDeJiuJitsu2025 = () => {
  const navigate = useNavigate();
  const { getToken, account } = useAuthenticate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const comboValue = 130;
  const giFiled = "valorInscricao";
  const noGiFiled = "valorInscricao";

  const slugGI = "open-challenger-de-jiu-jitsu-manaus-am-gi";
  const slugNOGI = "open-challenger-de-jiu-jitsu-manaus-am-nogi";

  const modalidade = [
    { title: "Não", option: 0 },
    { title: "Sim", option: 1 },
  ];

  let { slug } = useParams();
  let rulesGI = rulesOpenChallengerDeJiuJitsu2025Gi;
  let rulesNOGI = rulesOpenChallengerDeJiuJitsu2025NoGi;

  const [ages, setAges] = useState<any>([]);
  const [genre, setGenre] = useState<any>([]);
  const [categories, setCategories] = useState<any>([]);
  const [belts, setBelts] = useState<any>([]);
  const [weights, setWeights] = useState<any>([]);
  const [disabled, setDisabled] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);
  const [fighters, setFighters] = useState<any>([]);
  const [tournament, setTournament] = useState<any>({});
  const [modality, setModality] = useState<any>([]);
  const [enrollmentType, setEnrollmentType] = useState<String>("");
  const [categoriesNOGI, setCategoriesNOGI] = useState<any>([]);
  const [weightsNOGI, setWeightsNOGI] = useState<any>([]);
  const [selectedFighter, setSelectedFighter] = useState<any>(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [noCategoriesAvailable, setNoCategoriesAvailable] = useState<boolean>(false);
  const [noWeightsAvailable, setNoWeightsAvailable] = useState<boolean>(false);
  const [noCategoriesNOGIAvailable, setNoCategoriesNOGIAvailable] = useState<boolean>(false);
  const [noWeightsNOGIAvailable, setNoWeightsNOGIAvailable] = useState<boolean>(false);
  const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight, });
  const [selectedFighterId, setSelectedFighterId] = useState<number | null>(null);
  const handleEditAtlete = () => {
    setIsEditModalOpen(true);
  };

  const handleFighterUpdated = (updated: any) => {
    const updatedData = { ...selectedFighter, ...updated };
    if (selectedFighterId == 0) {
      account.name = updated.name;
    } else {
      setFighters((prev: any) =>
        prev.map((f: any) => (f.id === updated.id ? { ...f, ...updated } : f))
      );
    }
    setSelectedFighter(updatedData);
    setIsEditModalOpen(false);
    setValue("gi.category", "");
    setValue("gi.weight", "");
    setValue("gi.modalidade", "");
    setValue("nogi.category", "");
    setValue("nogi.weight", "");
    setValue("nogi.modalidade", "");
    setWeights([]);
    setWeightsNOGI([]);
    setModality([]);
    setNoCategoriesAvailable(false);
    setNoWeightsAvailable(false);
    setNoCategoriesNOGIAvailable(false);
    setNoWeightsNOGIAvailable(false);
    applyFighterLogic(updated);
  };

  const fields = [
    { id: 'name', label: 'Nome', value: selectedFighter?.name.toUpperCase() },
    { id: 'gym', label: 'Academia', value: selectedFighter?.gym.toUpperCase() },
    { id: 'belt', label: 'Faixa', value: belts[0]?.title || '' },
    { id: 'age', label: 'Idade de luta', value: ages[0]?.option },
    { id: 'gender', label: 'Gênero', value: selectedFighter?.genre.toUpperCase() },
  ];

  const [checkedStates, setCheckedStates] = useState<{ [key: string]: boolean }>(
    fields.reduce((acc, field) => ({ ...acc, [field.id]: false }), {})
  );

  const allChecked = fields.every(field => checkedStates[field.id]);

  const handleCheckChange = (id: string) => {
    setCheckedStates((prev) => {
      const updated = { ...prev };
      const currentIndex = fields.findIndex((f) => f.id === id);
      const newValue = !prev[id];

      updated[id] = newValue;

      if (!newValue) {
        for (let i = currentIndex + 1; i < fields.length; i++) {
          updated[fields[i].id] = false;
        }
      }

      return updated;
    });
  };

  const verifyCanSubscribe = async () => {
    const tournamentGI = (await api.get(`/tournaments/${slugGI}`)).data;

    const tournamentNOGI = (await api.get(`/tournaments/${slugNOGI}`)).data;

    return enrollmentType === "combo"
      ? tournamentGI!.canSubscribe && tournamentNOGI!.canSubscribe
      : enrollmentType === "nogi"
        ? tournamentNOGI!.canSubscribe
        : enrollmentType === "gi"
          ? tournamentGI!.canSubscribe
          : false;
  };

  const getTitleByOption = (array: any[], option: number) => {
    for (let i = 0; i < array.length; i++) {
      if (array[i].option === +option) {
        return array[i].title;
      }
    }
    return null;
  };

  const onSubmit = async (data: any) => {
    const canSubscribe = await verifyCanSubscribe();

    if (!canSubscribe) {
      const msg = "Período de inscrição encerrado.";

      Swal.fire({
        title: "Atenção!",
        text: msg,
        icon: "error",
      });

      toast.error(msg);
      return;
    }

    setDisabled(true);
    setLoading(true);

    const enrollmentIds: number[] = [];

    const arrBelts = [
      { title: "branca", option: 1 },
      { title: "cinza", option: 2 },
      { title: "amarela", option: 3 },
      { title: "laranja", option: 4 },
      { title: "verde", option: 5 },
      { title: "azul", option: 6 },
      { title: "roxa", option: 7 },
      { title: "marrom", option: 8 },
      { title: "preta", option: 9 },
    ];

    data.belt = getTitleByOption(arrBelts, data.belt);
    data.age = data.age.toString();
    delete data.fightingAge;

    if (enrollmentType === "gi" || enrollmentType === "combo") {
      // Verificando se `modalidade` é uma string ou número e ajustando a comparação
      const category =
        +data.gi.modalidade === 1
          ? "parajiu jitusu - " + data.gi.category
          : +data.gi.modalidade === 0
            ? data.gi.category
            : "";

      const valueSubscription = rulesGI.filter(
        (r) =>
          r.idade.min <= data.age &&
          r.idade.max >= data.age &&
          r.genero === data.genre &&
          r.faixa.some((f: any) => f.nome === data.belt) &&
          r.peso.descricao === data.gi.weight &&
          r.categoria === data.gi.category
      )[0];

      slug = "open-challenger-de-jiu-jitsu-manaus-am-gi";

      try {
        const dataEnrollment = await api.post(
          `${"/tournaments/enrollment/" + slug}`,
          {
            //...data,
            age: data.age,
            belt: data.belt,
            genre: data.genre,
            weight: data.gi.weight,
            category: category,
            fightersId: +data.fightersId,
            valueSubscription:
              enrollmentType === "combo"
                ? String(comboValue / 2)
                : String(valueSubscription[giFiled]),
            combo_subscription: enrollmentType === "combo" ? "GI" : null,
          },
          {
            headers: {
              Authorization: `Bearer ${getToken()}`,
            },
          }
        );

        enrollmentIds.push(dataEnrollment.data.id);
      } catch (error: any) {
        setDisabled(false);
        setLoading(false);
        Swal.fire({
          title: "Atenção!",
          text: error.response.data.message,
          icon: "error",
        });
        toast.error(
          error.response.data.message ||
          "Não foi possível gerar a sua pré-inscrição!"
        );
        return;
      }
    }

    if (enrollmentType === "nogi" || enrollmentType === "combo") {
      // Verificando se `modalidade` é uma string ou número e ajustando a comparação
      const category =
        +data.nogi.modalidade === 1
          ? "parajiu jitusu - " + data.nogi.category
          : +data.nogi.modalidade === 0
            ? data.nogi.category
            : "";

      const valueSubscription = rulesNOGI.filter(
        (r) =>
          r.idade.min <= data.age &&
          r.idade.max >= data.age &&
          r.genero === data.genre &&
          r.faixa.some((f: any) => f.nome === data.belt) &&
          r.peso.descricao === data.nogi.weight &&
          r.categoria === data.nogi.category
      )[0];

      slug = "open-challenger-de-jiu-jitsu-manaus-am-nogi";

      try {
        const dataEnrollment = await api.post(
          `${"/tournaments/enrollment/" + slug}`,
          {
            //...data,
            age: data.age,
            belt: data.belt,
            genre: data.genre,
            weight: data.nogi.weight,
            category: category,
            fightersId: +data.fightersId,
            valueSubscription:
              enrollmentType === "combo"
                ? String(comboValue / 2)
                : String(valueSubscription[noGiFiled]),
            combo_subscription: enrollmentType === "combo" ? "NOGI" : null,
          },
          {
            headers: {
              Authorization: `Bearer ${getToken()}`,
            },
          }
        );

        enrollmentIds.push(dataEnrollment.data.id);
      } catch (error: any) {
        setDisabled(false);
        setLoading(false);
        Swal.fire({
          title: "Atenção!",
          text: error.response.data.message,
          icon: "error",
        });
        toast.error(
          error.response.data.message ||
          "Não foi possível gerar a sua pré-inscrição!"
        );
        return;
      }
    }

    if (tournament.paymentManual) {
      toast.success("A sua pre-inscrição foi realizada com sucesso!");

      setTimeout(() => {
        navigate(
          "/payment-instruction/" +
          slug +
          "/" +
          enrollmentIds.toString().replace(",", "-")
        );
      }, 2000);

      return;
    }

    api
      .post(
        "/payments/checkout",
        {
          enrollmentId: enrollmentIds,
        },
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        }
      )
      .then((res: any) => {
        toast.success("A sua pre-inscrição foi realizada com sucesso!");
        const width = 800; // Largura da nova janela
        const height = 600; // Altura da nova janela
        const left = window.screen.width / 2 - width / 2; // Calcula a posição horizontal
        const top = window.screen.height / 2 - height / 2; // Calcula a posição vertical

        if (windowSize.width < width) {
          window.open(res.data.links[1].href, "_self");
        } else {
          window.open(res.data.links[1].href, "_self");
        }
      })
      .catch((error) => {
        setDisabled(false);
        setLoading(false);
        toast.error(
          error.response.data.message ||
          "Não foi possível gerar a sua pré-inscrição!"
        );
      });
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    // Limpeza do evento ao desmontar o componente
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    api
      .get("/fighters", {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then(({ data }) => {
        setLoading(false);
        setFighters([
          { id: "", name: "Selecione uma opção" },
          { id: 0, name: account.name },
          ...data,
        ]);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Não foi carregar os dados.");
      });

    api.get("tournaments/" + slug).then(({ data }) => {
      setTournament(data);
    });
  }, [account.name]);


  let weightsSerialize: any = [];
  let weightsSerializeNOGI: any = [];
  let categoriesSerialize: any = [];
  let categoriesSerializeNOGI: any = [];
  let arrWeights: any = [];
  let arrWeightsNOGI: any = [];
  let acc: any = account;
  let fightingAge: Number;
  let formattedGenre: String;

  const applyFighterLogic = async (fighter: any) => {

    let arrCategories: any = [];
    let arrCategoriesNOGI: any = [];
    let genre: any = [];
    let belts: any = [];

    const arrGenre = [
      { title: "Masculino", option: "masculino" },
      { title: "Feminino", option: "feminino" },
    ];

    const arrBelts = [
      { title: "Branca", option: 1 },
      { title: "Cinza", option: 2 },
      { title: "Amarela", option: 3 },
      { title: "Laranja", option: 4 },
      { title: "Verde", option: 5 },
      { title: "Azul", option: 6 },
      { title: "Roxa", option: 7 },
      { title: "Marrom", option: 8 },
      { title: "Preta", option: 9 },
    ];

    //============================== Genero ==============================
    genre = arrGenre.filter(
      (t) => t.option.toLowerCase() === fighter.genre.toLowerCase()
    );

    formattedGenre = genre[0]?.option.toLowerCase();
    //============================== Idade ==============================

    const dateOfTournament = new Date().getFullYear();
    const birthFightFromFighter = +fighter.birth_date
      .replace(/\//g, "-")
      .split("-")[2];
    fightingAge = dateOfTournament - birthFightFromFighter;
    setAges([{ title: fightingAge, option: fightingAge }]);

    //============================== Faixa ==============================
    belts = arrBelts.filter((b) => b.option === fighter.belt);
    setBelts(belts);

    //============================== Categoria ==============================
    rulesGI.map((item) => {
      if (
        item.idade.max >= +fightingAge &&
        item.idade.min <= +fightingAge &&
        item.genero === formattedGenre &&
        item.faixa.filter(
          (f: any) => f.nome.toLowerCase() === belts[0].title.toLowerCase()
        ).length
      ) {
        arrCategories.push({
          item: item.categoria,
          min: item.idade.min,
          max: item.idade.max,
          maxDescricao: item.idade.maxParaDescricao,
          minDescricao: item.idade.minParaDescricao,
          descricaoCompleta: item.idade.descricaoCompleta,
        });
      }
    });

    rulesNOGI.map((item) => {
      if (
        item.idade.max >= +fightingAge &&
        item.idade.min <= +fightingAge &&
        item.genero === formattedGenre &&
        item.faixa.filter(
          (f: any) => f.nome.toLowerCase() === belts[0].title.toLowerCase()
        ).length
      ) {
        arrCategoriesNOGI.push({
          item: item.categoria,
          min: item.idade.min,
          max: item.idade.max,
          maxDescricao: item.idade.maxParaDescricao,
          minDescricao: item.idade.minParaDescricao,
          descricaoCompleta: item.idade.descricaoCompleta,
        });
      }
    });

    let uniqueArray = [];
    let itemSet = new Set();

    for (const obj of arrCategories) {
      if (!itemSet.has(obj.item)) {
        itemSet.add(obj.item);
        uniqueArray.push(obj);
      }
    }

    categoriesSerialize = [...new Set(uniqueArray)].map((category: any) => {
      return {
        title:
          `${category.item} - ${category.descricaoCompleta}`.toUpperCase(),
        option: category.item,
      };
    });

    uniqueArray = [];
    itemSet = new Set();

    for (const obj of arrCategoriesNOGI) {
      if (!itemSet.has(obj.item)) {
        itemSet.add(obj.item);
        uniqueArray.push(obj);
      }
    }

    categoriesSerializeNOGI = [...new Set(uniqueArray)].map(
      (category: any) => {
        return {
          title:
            `${category.item} - ${category.descricaoCompleta}`.toUpperCase(),
          option: category.item,
        };
      }
    );

    // Verificar se há categorias disponíveis
    if (categoriesSerialize.length === 0) {
      setNoCategoriesAvailable(true);
      toast.warning("Não há categorias disponíveis para este atleta com base nos filtros aplicados.");
    }

    setGenre([...genre]);
    setBelts([...belts]);
    setValue("genre", genre[0]?.option);
    setValue("age", fightingAge);
    setValue("belt", belts[0]?.option);
    setValue("category", "");
    setCategories([
      {
        title: "Selecione uma opção",
        option: "",
      },
      ...categoriesSerialize,
    ]);
    setCategoriesNOGI([
      {
        title: "Selecione uma opção",
        option: "",
      },
      ...categoriesSerializeNOGI,
    ]);
    setSelectedFighter(fighter);

  }

  const handleChange = (e: any) => {
    setValue("category", "");
    setValue("weight", "");
    setValue("modalidade", "");
    setCategories([]);
    setCategoriesNOGI([]);
    setWeights([]);
    setWeightsNOGI([]);
    setModality([]);
    setNoCategoriesAvailable(false);
    setNoWeightsAvailable(false);
    setNoCategoriesNOGIAvailable(false);
    setNoWeightsNOGIAvailable(false);

    // RESETAR OS CHECKS COM APÓS MUDANÇA
    const resetStates = fields.reduce((acc, field) => {
      acc[field.id] = false;
      return acc;
    }, {} as { [key: string]: boolean });

    setCheckedStates(resetStates);

    const id = +e.target.value;
    setSelectedFighterId(id);

    if (id == 0) {
      applyFighterLogic(acc)
    } else {
      const fighter = fighters.find((f: any) => +f.id === id)!;
      applyFighterLogic(fighter)
    };
  }
  //============================== Peso ==============================
  const handleChangeWeights = (e: any) => {
    setValue("gi.modalidade", "");
    setValue("gi.weight", "");
    setNoWeightsAvailable(false);
    rulesGI.map((item) => {
      if (
        item.idade.max >= +ages[0].option &&
        item.idade.min <= +ages[0].option &&
        item.genero === genre[0].title.toLowerCase() &&
        item.categoria === e.target.value &&
        item.faixa.filter(
          (f: any) => f.nome.toLowerCase() === belts[0].title.toLowerCase()
        ).length
      ) {
        arrWeights.push({
          peso: item.peso.descricao,
          massa: item.peso.max,
        });
      }
    });

    weightsSerialize = [...new Set(arrWeights)].map((category: any) => {
      return {
        title: `${category.peso} - ${category.massa} `.toUpperCase(),
        option: category.peso,
      };
    });

    setWeights([
      {
        title: "Selecione uma opção",
        option: "",
      },
      ...weightsSerialize,
    ]);

    // Verificar se há pesos disponíveis
    if (weightsSerialize.length === 0) {
      setNoWeightsAvailable(true);
    } else {
      setNoWeightsAvailable(false);
    }
  };

  const handleChangeWeightsNOGI = (e: any) => {
    setValue("nogi.weight", "");
    setValue("nogi.modalidade", "");
    setNoWeightsNOGIAvailable(false);

    rulesNOGI.map((item) => {
      if (
        item.idade.max >= +ages[0].option &&
        item.idade.min <= +ages[0].option &&
        item.genero === genre[0].title.toLowerCase() &&
        item.categoria === e.target.value &&
        item.faixa.filter(
          (f: any) => f.nome.toLowerCase() === belts[0].title.toLowerCase()
        ).length
      ) {
        arrWeightsNOGI.push({
          peso: item.peso.descricao,
          massa: item.peso.max,
        });
      }
    });

    weightsSerializeNOGI = [...new Set(arrWeightsNOGI)].map((category: any) => {
      return {
        title: `${category.peso} - ${category.massa}`.toUpperCase(),
        option: category.peso,
      };
    });

    setWeightsNOGI([
      {
        title: "Selecione uma opção",
        option: "",
      },
      ...weightsSerializeNOGI,
    ]);


    if (weightsSerializeNOGI.length === 0) {
      setNoWeightsNOGIAvailable(true);
    } else {
      setNoWeightsNOGIAvailable(false);
    }
  };

  const handleChangeClasses = (e: any) => {
    setModality([
      {
        title: "Selecione uma opção",
        option: "",
      },
      ...modalidade,
    ]);
    setDisabled(false);
  };

  if (loading)
    return <Loading text="Aguarde, estamos processando a sua pré-inscrição." />;
  return (
    <div>
      <NavBar />

      <Content>
        <FormContainer onSubmit={handleSubmit(onSubmit)}>
          <PageTitle>Inscrição</PageTitle>
          <PageDescription>
            {/* Essa inscrição é referente ao torneio: {tournament.name} */}
            Essa inscrição é referente ao torneio: OPEN CHALLENGER DE JIU
            JITSU 2025
          </PageDescription>

          <SelectFighters
            label="Escolha um atleta para esse evento"
            name="fightersId"
            register={register}
            hasError={!!errors.category}
            required
            error="Este campo é obrigatório"
            options={fighters}
            onChange={handleChange}
          />

          {selectedFighter && (
            <Fade in={!!selectedFighter} timeout={800} unmountOnExit>
              <Box
                sx={{
                  border: '1px solid black',
                  borderRadius: 2,
                  padding: '8px 12px',
                  mt: 1,
                  position: 'relative',
                  backgroundColor: '#fefefe',
                }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography
                    component="span"
                    variant="h6"
                    sx={{ display: 'block' }}
                  >
                    Confirme seus dados:
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                  }}
                >

                  <Stack spacing={1} sx={{ m: 0, p: 0 }}>
                    {(() => {
                      const firstUncheckedIndex = fields.findIndex((field, index) => {
                        const previousChecked = index === 0 || checkedStates[fields[index - 1].id];
                        return previousChecked && !checkedStates[field.id];
                      });

                      return fields.map((field, index) => {
                        const isFirst = index === 0;
                        const previousChecked = isFirst || checkedStates[fields[index - 1].id];
                        const isCurrentChecked = checkedStates[field.id];
                        const shouldShowEditIcon = index === firstUncheckedIndex;

                        return (
                          <Box
                            key={field.id}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              opacity: previousChecked ? 1 : 0.4,
                              pointerEvents: previousChecked ? 'auto' : 'none',
                              transition: 'opacity 0.2s',
                            }}
                          >
                            <Checkbox
                              checked={isCurrentChecked}
                              onChange={() => handleCheckChange(field.id)}
                              color="primary"
                            />

                            <Typography
                              component="div"
                              sx={{
                                fontWeight: 500,
                                fontSize: '0.95rem',
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              {field.label}:{' '}
                              <Box
                                component="span"
                                sx={{
                                  color: isCurrentChecked ? 'success.main' : 'error.main',
                                  fontWeight: 500,
                                  fontSize: 'inherit',
                                  ml: 1,
                                }}
                              >
                                {field.value}
                              </Box>

                              {shouldShowEditIcon && (
                                <Box
                                  onClick={handleEditAtlete}
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    ml: 1.5,
                                    cursor: 'pointer',
                                    color: 'text.secondary',
                                    transition: 'color 0.2s',
                                    '&:hover': { color: 'black' },
                                  }}
                                >
                                  <Typography variant="body2" sx={{ mr: 0.5 }}>
                                    Editar
                                  </Typography>
                                  <EditIcon sx={{ fontSize: '1.2rem' }} />
                                </Box>
                              )}

                            </Typography>
                          </Box>
                        );
                      });
                    })()}
                  </Stack>
                </Box>
              </Box>
            </Fade>
          )}

          <br />

          <NoOptionsAlert
            show={noCategoriesAvailable && !!selectedFighter && allChecked}
            type="categories"
            fighterData={{
              name: selectedFighter?.name || "",
              age: ages[0]?.option,
              gender: genre[0]?.title,
              belt: belts[0]?.title,
            }}
          />

          <br />
          <Collapse in={allChecked} timeout={800} unmountOnExit>
            <Box>
              {allChecked && !noCategoriesAvailable && (
                <>
                  <FormControl>
                    <FormLabel id="demo-row-radio-buttons-group-label" style={{ color: "#33303E" }}>
                      Tipo da Inscrição
                    </FormLabel>
                    <RadioGroup
                      aria-label="Filtrar por"
                      value={enrollmentType}
                      onChange={(e: any) => {
                        setEnrollmentType(e.target.value);
                        setValue("gi.category", "");
                        setValue("gi.weight", "");
                        setValue("gi.modalidade", "");
                        setValue("nogi.category", "");
                        setValue("nogi.weight", "");
                        setValue("nogi.modalidade", "");
                        setWeights([]);
                        setWeightsNOGI([]);
                        setModality([]);
                      }}
                      row
                    >
                      <FormControlLabel value="gi" control={<Radio />} label="GI" />
                      <FormControlLabel value="nogi" control={<Radio />} label="NOGI" />
                      <FormControlLabel value="combo" control={<Radio />} label="COMBO (GI + NOGI)" />
                    </RadioGroup>
                  </FormControl>

                  <Collapse in={enrollmentType === "gi" || enrollmentType === "combo"} timeout={800} unmountOnExit>
                    {(enrollmentType === "gi" || enrollmentType === "combo") && (
                      <>
                        <PageTitle>GI</PageTitle>

                        <SelectCategories
                          label="Categoria"
                          name="gi.category"
                          register={register}
                          required
                          hasError={!!errors.category}
                          error="Este campo é obrigatório"
                          options={categories}
                          onChange={handleChangeWeights}
                        />

                        <SelectCategories
                          label="Peso"
                          name="gi.weight"
                          register={register}
                          required
                          hasError={!!errors.category}
                          error="Este campo é obrigatório"
                          options={weights}
                          onChange={handleChangeClasses}
                        />

                        <SelectCategories
                          label="Pessoa com deficiência - PcD?"
                          name="gi.modalidade"
                          register={register}
                          required
                          hasError={!!errors.modalidade}
                          error="Este campo é obrigatório"
                          options={modality}
                        />
                      </>
                    )}
                  </Collapse>

                  <Collapse in={enrollmentType === "nogi" || enrollmentType === "combo"} timeout={800} unmountOnExit>
                    {(enrollmentType === "nogi" || enrollmentType === "combo") && (
                      <>
                        <PageTitle>NOGI</PageTitle>

                        <SelectCategories
                          label="Categoria"
                          name="nogi.category"
                          register={register}
                          required
                          hasError={!!errors.category}
                          error="Este campo é obrigatório"
                          options={categoriesNOGI}
                          onChange={handleChangeWeightsNOGI}
                        />

                        <SelectCategories
                          label="Peso"
                          name="nogi.weight"
                          register={register}
                          required
                          hasError={!!errors.category}
                          error="Este campo é obrigatório"
                          options={weightsNOGI}
                          onChange={handleChangeClasses}
                        />

                        <SelectCategories
                          label="Pessoa com deficiência - PcD?"
                          name="nogi.modalidade"
                          register={register}
                          required
                          hasError={!!errors.modalidade}
                          error="Este campo é obrigatório"
                          options={modality}
                        />
                      </>
                    )}
                  </Collapse>
                </>
              )}
            </Box>
          </Collapse>

          {selectedFighter && allChecked && (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button type="submit" label="Inscrever" disabled={disabled} />
            </Box>
          )}

        </FormContainer>

        {isEditModalOpen && (
          <EditFighterModal
            targetValue={selectedFighterId}
            fighter={selectedFighter}
            onUpdated={handleFighterUpdated}
            open={true}
            onClose={() => setIsEditModalOpen(false)}
          />
        )}

      </Content>
    </div>
  );
};

export default EnrollmentOpenChallengerDeJiuJitsu2025;
